require('./users-template.html');
require('./invite-template.html');

var export2CSV = require('../../common/export-csv');

angular.module('bbl.module.users.controller', [])
  .controller('UsersController', [
    '$scope', 'Auth', 'Api', '$compile', '$window', '$timeout', '$routeParams', 'Toast',
    usersController
  ]);

function usersController($scope, Auth, Api, $compile, $window, $timeout, $routeParams, Toast) {
  $scope.subuserSelected = {};
  $scope.subuserInvited = {};

  function init(){
    // Get the subusers
    Auth.getSubUsers().then(
      function(response) {
        $scope.owner = response.data.owner;
        $scope.subusers = JSON.parse(response.data.subusers);
      }
    );

    Api.bridges.sub(function(bridges){ $scope.bridges = bridges; });
    Api.bridges.fetch();
  }

  if($routeParams.token === undefined) {
    init();
  }

  $scope.showEdit = function(pk){
    // Search the subuser
    for (var i = 0; i < $scope.subusers.length; i++) {
      if ($scope.subusers[i].pk == pk){
        $scope.subuserSelected = angular.extend({pk: pk}, $scope.subusers[i], $scope.subusers[i].fields);
        $scope.subuserSelected.linesObj = $scope.subuserSelected.lines.reduce(function(p, c) {
          p[c] = true;
          return p;
        }, {});
        // force line select element to be re-rendered
        $scope.bridges = angular.copy($scope.bridges);
        break;
      }
    }

    $("#invite").hide();
    $("#invite-btns").hide();

    $("#edit").show();
    $("#edit-btns").show();


  };

  $scope.showInvite = function(){
    $("#lines-invited").val([]);

    $("#edit").hide();
    $("#edit-btns").hide();

    $("#invite").show();
    $("#invite-btns").show();


  };

  $scope.cancel = function(){
    $("#edit").hide();
    $("#edit-btns").hide();
    $("#invite").hide();
    $("#invite-btns").hide();
    $("#confirmationDelete").modal('hide');
  };

  $scope.cancelDelete = function(){
    $("#confirmationDelete").modal('hide');
  };

  $scope.updateSubuser = function(){
    var lines = $("#lines").val();

    var permission_level = +$scope.subuserSelected.permission_level;
    var first_name = $scope.subuserSelected.first_name;
    var last_name = $scope.subuserSelected.last_name;
    var email = $scope.subuserSelected.email;

    if (!first_name) {
      Toast.error("Please complete the field first name");
    }

    else if (!last_name) {
      Toast.error("Please complete the field last name");
    }

    else if (!email) {
      Toast.error("Please complete the field email");
    }

    else if (lines || (!lines && permission_level === 3)) {
      $scope.subuserSelected.lines = JSON.stringify(lines);
      Auth.updateSubuser($scope.subuserSelected).then(
        function() {
          Toast.notify('User updated successfully');
          $window.location.reload();
        },
        function(error) {
          Toast.error(error.data.msg);
        }
      );
    }
    else {
      Toast.error('Please select one or more lines before');
    }
  };

  $scope.inviteSubuser = function(){
    var lines = $("#lines-invited").val();

    var permission_level = +$scope.subuserInvited.permission_level;
    var first_name = $scope.subuserInvited.first_name;
    var last_name = $scope.subuserInvited.last_name;
    var email = $scope.subuserInvited.email;

    if (!first_name) {
      Toast.error("Please complete the field first name");
    } else if (!last_name) {
      Toast.error("Please complete the field last name");
    } else if (!email) {
      Toast.error("Please complete the field email");
    } else if (lines || lines === null && permission_level === 3) {
      $scope.subuserInvited.lines = JSON.stringify($("#lines-invited").val());

      Auth.inviteSubuser($scope.subuserInvited).then(function() {
        Toast.notify('User invited successfully');
        $window.location.reload();
      }, function(error) {
        Toast.error(error.data.msg);
      });
    } else {
      Toast.error('Please select one or more lines before');
    }
  };

  $scope.createSubuser = function($event){
    $event.preventDefault();

    if ($scope.data.password1 !== $scope.data.password2) {
      $scope.errorMessage = "The two password fields didn't match.";
    } else {
      $(":submit").attr("disabled", true);
      Auth.createSubuser($routeParams.token, $scope.data.password1).then(function() {
        $window.location.replace("/app");
      }, function(error) {
        $(":submit").removeAttr("disabled");
        $scope.errorMessage = error.data.msg;
      });
    }
  };

  $scope.confirmDeleteSubuser = function(){
    $("#confirmationDelete").modal('show');
  };

  $scope.deleteSubuser = function(){
    Auth.deleteSubuser($scope.subuserSelected.pk);
    Toast.notify('User deleted successfully');
    $window.location.reload();
  };

  $scope.exportUsersList = function() {
    var subusers = $scope.subusers || [];
    var bridges = ($scope.bridges || []).reduce(function(p, c) {
      p[c.id] = c.friendly_phone + ' ' + c.title;
      return p;
    }, {});
    var users = subusers.map(function(user) {
      return {
        'First Name': user.fields.first_name,
        'Last Name': user.fields.last_name,
        'Email': user.fields.email,
        'Permissions': {1: 'Dashboard(s) Only', 2: 'Line Configuration(s)', 3: 'Full Privileges'}[user.fields.permission_level],
        'Lines': user.fields.permission_level < 3 ? user.fields.lines.map(function(d) { return bridges[d] || d;}) : '',
      };
    });
    export2CSV(users);
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/users/users.controller.js
 ** module id = 377
 ** module chunks = 0
 **/